import React from 'react';
import Icon from '../../../components/AppIcon';


const FeedHeader = ({ sortMode, onSortChange, onLogoClick }) => {
  return (
    <header className="sticky top-0 z-50 bg-card border-b border-border">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <button
            onClick={onLogoClick}
            className="flex items-center gap-2 md:gap-3 hover:opacity-80 transition-base"
            aria-label="Nubi Home"
          >
            <div className="w-8 h-8 md:w-10 md:h-10 bg-primary rounded-xl flex items-center justify-center">
              <Icon name="Sparkles" size={20} color="white" strokeWidth={2.5} />
            </div>
            <span className="text-xl md:text-2xl font-heading font-semibold text-foreground">
              Nubi
            </span>
          </button>

          <div className="flex items-center gap-2 md:gap-3">
            <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
              <button
                onClick={() => onSortChange('algorithmic')}
                className={`px-3 md:px-4 py-2 rounded-md transition-base caption font-medium ${
                  sortMode === 'algorithmic' ?'bg-card text-foreground shadow-sm' :'text-muted-foreground hover:text-foreground'
                }`}
                aria-label="Algorithmic feed"
                aria-pressed={sortMode === 'algorithmic'}
              >
                <span className="hidden md:inline">For You</span>
                <Icon name="Sparkles" size={16} className="md:hidden" />
              </button>
              <button
                onClick={() => onSortChange('chronological')}
                className={`px-3 md:px-4 py-2 rounded-md transition-base caption font-medium ${
                  sortMode === 'chronological' ?'bg-card text-foreground shadow-sm' :'text-muted-foreground hover:text-foreground'
                }`}
                aria-label="Chronological feed"
                aria-pressed={sortMode === 'chronological'}
              >
                <span className="hidden md:inline">Following</span>
                <Icon name="Clock" size={16} className="md:hidden" />
              </button>
            </div>

            <button
              className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg hover:bg-muted transition-base"
              aria-label="Notifications"
            >
              <div className="relative">
                <Icon name="Bell" size={20} strokeWidth={2} />
                <span className="absolute -top-1 -right-1 w-2 h-2 bg-error rounded-full"></span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default FeedHeader;